export default __webpack_public_path__ + "static/media/CovidTrackerSpecificCountryPage.700f1f1e.PNG";